import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useApi } from '../services/api'; // FIXED: Import useApi hook for authenticated API
import { Button, Card, Input, Label } from './ui/primitives';

const schema = z.object({
  name: z.string().min(1, 'Company name required'),
  industry: z.string().optional(),
  size: z.string().optional()
});

type FormData = z.infer<typeof schema>;

const CompanySetupForm = () => {
  const { register, handleSubmit, formState: { errors } } = useForm<FormData>({ resolver: zodResolver(schema) });
  const api = useApi(); // FIXED: Use the hook to get authenticated api instance
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState('');
  const setupMessage = typeof location.state === 'object'
    && location.state !== null
    && 'setupMessage' in location.state
    && typeof location.state.setupMessage === 'string'
    ? location.state.setupMessage
    : '';

  const onSubmit = async (data: FormData) => {
    setErrorMessage('');
    try {
      const response = await api.post('/auth/company', data);
      console.log('Company success:', response.data);
      navigate('/employer/dashboard');
    } catch (error: any) {
      console.error('Company error:', error.response?.data || error.message);
      setErrorMessage(error.response?.data?.error || 'An error occurred. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-surface-page flex items-center justify-center px-4 py-10">
      <Card className="w-full max-w-md">
        <h2 className="text-[22px] md:text-page-title font-display font-bold text-txt-primary text-center">
          Company Setup
        </h2>
        {setupMessage && <p className="mt-3 text-small text-txt-secondary">{setupMessage}</p>}
        <form onSubmit={handleSubmit(onSubmit)} className="mt-5 space-y-4">
          <div>
            <Label htmlFor="company-name">Company Name</Label>
            <Input id="company-name" {...register('name')} placeholder="Company Name" />
            {errors.name && <p className="text-danger text-small mt-1">{errors.name.message}</p>}
          </div>
          <div>
            <Label htmlFor="company-industry">Industry</Label>
            <Input id="company-industry" {...register('industry')} placeholder="Industry" />
          </div>
          <div>
            <Label htmlFor="company-size">Size</Label>
            <Input id="company-size" {...register('size')} placeholder="Size (e.g., 1-10)" />
          </div>
          <Button type="submit" fullWidth>Create Company</Button>
          {errorMessage && <p className="text-danger text-small">{errorMessage}</p>}
        </form>
      </Card>
    </div>
  );
};

export default CompanySetupForm;
